/**
 * 文件删除API接口
 */
export const FileDeleteApi = Symbol.for('FileDeleteApi');

/**
 * 文件类型
 */
export type FileContentType = 'DISCLOSURE' | 'CLAIM';

/**
 * 文件删除请求参数
 */
export interface FileDeleteRequest {
    /**
     * 任务ID
     */
    taskId: string;
    /**
     * 文件类型
     */
    contentType: FileContentType;
}

/**
 * 文件删除API接口
 */
export interface FileDeleteApi {
    /**
     * 删除文件
     * @param data 删除文件请求参数
     * @returns 删除是否成功
     */
    deleteFile(data: FileDeleteRequest): Promise<boolean>;
}
